
// use this when we want to submit on onChange
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit() {
    refreshCSRFTokens();
    this.element.requestSubmit()
  }
}
